module.exports = __webpack_public_path__ + "img/30.3e1e3391.png";